import {Bin} from '../bin';
import {PlacedBin} from '../placed-bin';
import {CORNER_DEF_GETTERS, CornerDef} from './corner-def';
import {FourPlacedBins} from './four-placed-bins';
import {getPosHash} from './pos-hash';

const BIN_POS_AROUND_CORNER_GETTERS: Array<(x: number, y: number, bin: Bin) => [number, number]> = [
    (x, y, bin) => [x - bin.w, y - bin.h],
    (x, y, bin) => [x, y - bin.h],
    (x, y) => [x, y],
    (x, y, bin) => [x - bin.w, y]
];

export class Corner {

    public static collectCorners(placedBins: PlacedBin[]): Corner[] {
        const corners: Corner[] = [];
        const cornersHash: {[posHash: string]: Corner} = {};

        placedBins.forEach(placedBin => {
            CORNER_DEF_GETTERS
                .map(cornerDefGetter => cornerDefGetter(placedBin))
                .forEach(cornerDef => {
                    const hash = getPosHash(cornerDef.x, cornerDef.y);
                    const corner: Corner = cornersHash[hash];

                    if (corner) {
                        corner.addDef(cornerDef);
                    } else {
                        corners.push(new Corner(cornerDef));
                    }
                });
        });

        return corners;
    }

    public binsAround: FourPlacedBins;
    public x: number;
    public y: number;

    constructor(cornerDef: CornerDef) {
        this.x = cornerDef.x;
        this.y = cornerDef.y;

        this.binsAround = [null, null, null, null];
        this.addDef(cornerDef);
    }

    public addDef(cornerDef: CornerDef): Corner {
        this.binsAround[cornerDef.binIndex] = cornerDef.placedBin;

        return this;
    }

    public createPlacedBin(bin: Bin, binIndex: number): PlacedBin {
        const {w, h} = bin;
        const [x, y] = BIN_POS_AROUND_CORNER_GETTERS[binIndex](this.x, this.y, bin);

        return PlacedBin.createFromDef({x, y, w, h});
    }

}
